import React, { useEffect } from 'react';
import styled from 'styled-components';
import Button from 'gatsby-theme-core/src/components/button/index';
import Times from 'icons/src/Times';
import { useNav } from '../provider';

const CloseButton = (props) => {
  const { setOpen } = useNav();

  useEffect(() => {
    const closeOnEscape = (event) => {
      if (event.key === 'Escape') {
        setOpen(false);
      }
    };

    window.addEventListener('keydown', closeOnEscape);
    return () => {
      window.removeEventListener('keydown', closeOnEscape);
    };
  }, [
    setOpen,
  ]);

  return (
    <Button
      {...props}
      onClick={() => setOpen(false)}
      eventActionResult="close"
    >
      <Times />
      sluiten
    </Button>
  );
};

export default styled(CloseButton).attrs({
  wrapper: true,
  nav: true,
  navType: 'hamburger_menu',
  eventAction: 'close',
})`
  display: flex;
  text-transform: uppercase;
  color: white;
  font-weight: 700;

  svg {
    height: 2rem;
    width: 1.25rem;
    margin-right: .5rem;
  }
`;
